export default "__VITE_ASSET__yYbChHg1__"